import React, { FC } from 'react';
import { AddCrewChangeRequestError } from '@bechtel/types';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { Trans, t } from '@lingui/macro';
import { AddCrewChangeRequestCustomError, CrewChangeRequestErrorProps } from './types';
import { FooterButtonStyled } from '../styled';

const getErrorMessage = (error: CrewChangeRequestErrorProps['addCrewChangeError']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case AddCrewChangeRequestError.MISSING_REQUIRED_PERMISSION:
      return <Trans>Sorry, you do not have rights to create crew change request.</Trans>;
    case AddCrewChangeRequestError.ALREADY_REQUEST_PENDING_FOR_APPROVAL:
      return <Trans>Sorry, a pending request is already there in the system for this crew change.</Trans>;
    case AddCrewChangeRequestError.CREW_DATA_NOT_FOUND:
      return <Trans>Crew data not found for this request.</Trans>;
    case AddCrewChangeRequestCustomError.ORIGIN_FM_SAME_AS_DEST_FM:
      return <Trans>Origin and Destination Foreman cannot be same.</Trans>;
    case AddCrewChangeRequestCustomError.ORIGIN_GF_SAME_AS_DEST_GF:
      return <Trans>Origin and Destination General Foreman cannot be same.</Trans>;
    case AddCrewChangeRequestCustomError.USER_NOT_IN_ORIGIN_DEST:
      return <Trans>You have to be part of request, either in Original or Destination Crew.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

export const CrewChangeRequestError: FC<CrewChangeRequestErrorProps> = ({ addCrewChangeError, close }) => {
  return (
    <Modal
      visible
      size={ModalSize.DEFAULT}
      data-testid="add-crew-change-error"
      style={{ width: '552px', height: '275px' }}
    >
      <ModalHeader title={t`Crew Change Request Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(addCrewChangeError)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <FooterButtonStyled appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans>Close</Trans>
            </FooterButtonStyled>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};

export default CrewChangeRequestError;
